<dacks-content (right-aside-close-click)="onRightAsideCloseClick()">
<!-- TODO Texte auslagern -->
  <dacks-content-right-aside [ngClass]="{'hidden': !isLargeScreenWithRightAside}" slot="right-aside"
                             heading="Details" [open]="!!selectedProduct" size="extra-large">
    @if (!!selectedProduct) {
      <button mat-button class="mr-auto mb-6 mt-4" (click)="navigateToProductDetails(selectedProduct)">Ansicht vergrößern</button>
      @if (selectedProduct.documentUrl) {
        @if ((documentBuffer$ | async); as buffer) {
          <div class="w-full overflow-hidden">
            <doc-viewer
              class="relative w-full aspect-[2/3] z-0 doc-viewer-responsive-workaround"
              [src]="buffer"
              disableDocumentHeadline="true" disableAttachments="true" disableTableOfContents="true"
            ></doc-viewer>
          </div>
        } @else {
          @if (detailsContentError$ | async) {
            <ng-container *ngTemplateOutlet="errorDisplay; context: {
                    errorTitle: ('delivery-product-details.error_title' | translate),
                    errorText: ('delivery-product-details.error_document_viewer' | translate)}">
            </ng-container>
          } @else {
            <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
          }
        }
      } @else {
        <myupdates-html-viewer class="document-viewer-base document-viewer-product" [documentId]="selectedProduct.documentId">
        </myupdates-html-viewer>
        @if (detailsContentError$ | async) {
          <ng-container *ngTemplateOutlet="errorDisplay; context: {
                    errorTitle: ('delivery-product-details.error_title' | translate),
                    errorText: ('delivery-product-details.error_document_viewer' | translate)}">
          </ng-container>
        }
      }
    } @else {
<!--   Dieser Zweig sollte nie aktiv werden -->
      <p>Wählen Sie ein Produkt aus, um weitere Details zu erhalten.</p>
    }

    <footer-spacing type="aside" />
  </dacks-content-right-aside>

  <div class="p-4 md:p-6">
    @if ((deliveryViewModel$ | async); as delivery) {
      <div class="flex items-center gap-x-4">
        <!-- TODO sobald dacks-content-header auch mehrzeilig sein kann, die h1 damit umsetzen -->
        <h1 class="mu-heading-3 md:mu-heading-2 text-petrol-650">{{ delivery.description.deliveryName }} {{ delivery.description.deliveryDate |
          date:'dd.MM.yyyy' }} um {{ delivery.description.deliveryDate | date:'HH:mm' }} Uhr</h1>
        <button mat-button class="hidden md:inline-flex ml-auto flex-shrink-0" aria-label="Teilen per Mail" color="light" (click)="shareByMail(delivery.description)">
          <mat-icon svgIcon="fi-teilen-20"></mat-icon>
          <span>{{ 'common.caption_share' | translate }}</span>
        </button>
        <button mat-fab class="md:hidden ml-auto flex-shrink-0" aria-label="Teilen per Mail" color="light" (click)="shareByMail(delivery.description)">
          <mat-icon svgIcon="fi-teilen-20"></mat-icon>
        </button>
      </div>
      @if (isLegalNoticeShown) {
        <div class="sm:pl-3.5 md:pl-6 text-sm md:text-base">{{'delivery.legal_notice' | translate}}</div>
      }

      @if (appState.isPersonalized$ | async) {
        <mat-slide-toggle class="mt-3.5" [checked]="appState.isPersonalDeliveryFilter"
                          (change)="changePersonalFilterState($event)">{{'filter-group.personalize_toggle' | translate}}</mat-slide-toggle>
      }
      @if (delivery.description.deliveryType === DeliveryType.ServiceReleaseAndHotfix) {
        <mat-tab-group
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          class="on-light-bg mt-6"
          (selectedTabChange)="onTabChange()"
        >
          <mat-tab [label]="'Service-Releases (' + delivery.serviceReleasesAndFullVersion.length + ')'">
            <div class="bg-white py-6 px-4 m-0 rounded-tr rounded-b">
              <ng-container *ngTemplateOutlet="productList; context: {products: delivery.serviceReleasesAndFullVersion, displayDeliveryBasesAndDataTransformation: true}">
              </ng-container>
            </div>
          </mat-tab>
          <mat-tab [label]="'Hotfixes (' + delivery.hotfixes.length + ')'">
            <div class="bg-white py-6 px-4 m-0 rounded-tr rounded-b">
              <ng-container *ngTemplateOutlet="productList; context: {products: delivery.hotfixes, displayDeliveryBasesAndDataTransformation: false}">
              </ng-container>
            </div>
          </mat-tab>
        </mat-tab-group>
      } @else {
        <mat-card class="mt-6">
          <ng-container *ngTemplateOutlet="productList;
             context: {products: delivery.allProducts, displayDeliveryBasesAndDataTransformation: delivery.description.deliveryType !== DeliveryType.Hotfix}">
          </ng-container>
        </mat-card>
      }
    } @else {
      @if (errorInfo$ | async) {
        <myupdates-error-box class="error-box-dimmed-style"
                             [errorTitle]="'delivery-products.error_title' | translate"
                             [errorText]="'delivery-products.error_text' | translate">
        </myupdates-error-box>
      } @else {
        <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
      }
    }
  </div>

  <footer-spacing type="content" />
</dacks-content>


<ng-template #productList let-products="products" let-displayDeliveryBasesAndDataTransformation="displayDeliveryBasesAndDataTransformation">
  @if ((products?.length ??-1)>0) {
    <div>
      <div class="px-4 md:px-0 pb-4 text-sm md:text-base text-black text-opacity-70">{{ 'delivery-products.installation_hint' | translate }}</div>
      <div class="hidden md:block">
        <myupdates-delivery-products-table-view
          [products]="products"
          [displayDeliveryBasesAndDataTransformation]="displayDeliveryBasesAndDataTransformation"
          [changeCategoriesVerticalOrientation]="true"
          [selectedProduct]="selectedProduct"
          [enableInlineSelection]="isLargeScreenWithRightAside"
          (productSelected)="selectProduct($event)"
        ></myupdates-delivery-products-table-view>
      </div>
      <div class="md:hidden mt-3 flex flex-col gap-4">
        @for (product of products; track product) {
          <div role="region" [attr.aria-label]="product.title">
            <mat-card class="show-focus-coldgray-50 flex flex-row items-center p-4 relative" [tabindex]="(product.documentId || product.documentUrl) ? -1 : 0">
              <div class="grow flex flex-col min-w-0">
                <div class="mu-heading-5 mb-2">{{product.title}}</div>
                <myupdates-change-categories class="pb-1" [changeCategories]="product.changeCategories"></myupdates-change-categories>
                @if (displayDeliveryBasesAndDataTransformation) {
                  <div class="flex flex-col gap-4 sm:grid sm:grid-cols-2 font-normal text-[#0F0F0F]">
                    <div [ngClass]="{'hidden sm:block': !product.deliveredByRdt}">
                      @if (product.deliveredByRdt) {
                        <p class="font-medium">{{ 'delivery-products.product_base_delivery_information' | translate }}</p>
                      }
                      @if (product.deliveredByRdt) {
                        <myupdates-delivery-bases [deliveryBases]="product.deliveryBases"></myupdates-delivery-bases>
                      }
                    </div>
                    <div>
                      <div class="font-medium">{{ 'delivery-products.product_data_transformation' | translate }}</div>
                      <div>{{product.dataTransformation | yesNo}}</div>
                    </div>
                  </div>
                }
              </div>
              <div class="w-5">
                @if (product.documentId || product.documentUrl) {
                  <a class="no-underline outline-none" [attr.aria-label]="'Mehr zu ' + product.title"
                     [routerLink]="['product', product.id]" id="md:a_{{product.id}}" tabindex="0">
                    <mat-icon svgIcon="sli-pfeil-rechts-20" aria-hidden="true"></mat-icon>
                    <span class="absolute inset-0 z-[2]"></span>
                  </a>
                }
              </div>
            </mat-card>
          </div>
        }
      </div>
    </div>
  } @else {
    <dackl-empty-state size="XS">
      @if (!(appState.isPersonalized$ | async)) {
        <div>
              <span  class="text-center font-semibold">
                {{ 'delivery-products.empty_product_list' | translate }}
              </span>
        </div>
      }
      @if ((appState.isPersonalized$ | async)) {
        <div>
          <div class="flex flex-col gap-6">
                <span  class="text-center font-semibold">
                  {{ 'delivery-products.empty_product_list_personalized' | translate }}
                </span>
          </div>
        </div>
      }
    </dackl-empty-state>
  }
</ng-template>

<ng-template #errorDisplay let-errorTitle="errorTitle" let-errorText="errorText">
  <div class="flex items-center">
    <mat-icon class="w-7 h-7" svgIcon="fi-fehler-20"></mat-icon>
    <div class="mu-heading-2 pl-[0.8rem]">{{ errorTitle }}</div>
  </div>
  <div class="pt-4 pl-[2.8rem]">
    {{ errorText }}
  </div>
</ng-template>
